import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import request from '@/utils/request.js'
import tool from '@/utils/tool.js'

// 公共仓库
import store from '@/store'

// 请求
Vue.prototype.request = request

Vue.use(ElementUI)
Vue.use(tool) // 工具
Vue.use(store) // 公共仓库

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
